// Crew — Card surface (Agent B).
import type { ReactNode } from 'react';

export function Card({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <section className={`rounded-xl2 bg-white/80 p-5 shadow-sm ring-1 ring-sand-200 ${className}`}>
      {children}
    </section>
  );
}

export function CardTitle({ children, className = '' }: { children: ReactNode; className?: string }) {
  return <h2 className={`text-lg font-semibold tracking-tight text-ink-900 ${className}`}>{children}</h2>;
}
